module.exports = __webpack_public_path__ + "img/leighton_b2.c0543ea0.jpg";